import { Col, Divider, Row } from 'antd';
import React from 'react';
import PageFooter from './PageFooter';

interface FooterProps {
  style?: React.CSSProperties;
}

const Footer = function ({ style }: FooterProps) {
  const year = new Date().getFullYear();
  return (
    <PageFooter style={style}>
      <Divider />
      <Row justify="space-between">
        <Col>
          &copy; {`${year} `}
          <a
            href="https://www.guuru.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            GUURU
          </a>
          <Divider orientation="vertical" />
          Connect your customers
        </Col>
        <Col>
          <a
            href="https://www.guuru.com/en/terms-of-service"
            rel="noopener noreferrer"
            target="_blank"
          >
            Terms of Service
          </a>

          <Divider orientation="vertical" />

          <a
            href="https://www.guuru.com/en/privacy-policy"
            rel="noopener noreferrer"
            target="_blank"
          >
            Privacy Policy
          </a>
        </Col>
      </Row>
    </PageFooter>
  );
};

export default Footer;
